<div #filterPanel class="filters-panel inverse-surface overlay" [class.expand-filters-panel] = "filterExpanded" >
    <div class="row justify-content-end m-1">
        <div class="col-7 align-self-center mat-font-title-md">
            Capture program
        </div>
        <div class="col-2">
            <button matIconButton (click)="closePanel()"><mat-icon>close</mat-icon></button>
        </div>
    </div>
    @for (layerType of  filters.layerTypes; track layerType.value) {
        <div [class.filter-empty]="enabled && empty(layerType)" matTooltip="{{getCheckboxTooltip(layerType)}}">
            <mat-checkbox class="d-flex" [disabled]="!available(layerType)"
                          (change)="changeFilterValue('layerTypes',layerType.value, $event.checked)" [value]="layerType.value"
                          [checked]="layerType.checked">{{layerType.title}}
                <span class="type" [class]="layerType.style">{{layerType.type || ''}}</span>
                <span> {{layerType.description || ''}}</span>
            </mat-checkbox>
        </div>
    }
</div>
